import { Flex, HeaderContainer, RemoteImage } from '@banhala/ui-kit';
import { CartIcon } from 'shared/src/component';
import { useHomeIcons } from './queries/useHomeIcons';
import { bridge, isNil, isNotNil } from 'shared/src/utils';
import React, { useCallback } from 'react';
import Svg, { Path } from 'react-native-svg';

const HomeHeaderContent = () => {
  const { data: homeIcons } = useHomeIcons();
  const onPressLogo = useCallback(() => {
    if (isNil(homeIcons.logo)) return;
    if (isNotNil(homeIcons.logo.deeplink)) {
      bridge.openDeeplink(homeIcons.logo.deeplink);
    }
  }, [homeIcons.logo]);
  return (
    <HeaderContainer justifyContent={'space-between'}>
      <Flex justifyContent={'center'} padding={{ left: 12 }}>
        {isNotNil(homeIcons.logo) ? (
          <Flex onPress={onPressLogo}>
            <RemoteImage
              uri={homeIcons.logo.image_url}
              width={homeIcons.logo.image_width}
              height={homeIcons.logo.image_height}
            />
          </Flex>
        ) : (
          <Flex>
            <Svg width="80" height="16" viewBox="0 0 80 16" fill="none">
              <Path
                d="M32.981 0.0351562C35.0942 0.116157 37.0747 1.88043 37.0747 4.03125C37.0776 4.06614 37.2938 6.79561 35.0249 7.5332C34.9691 7.55245 34.8732 7.57359 34.8208 7.59082C34.8322 7.59312 34.8436 7.59702 34.855 7.59961C36.5888 7.98567 37.8969 9.55149 37.897 11.4121V12.0381C37.897 14.1863 36.1566 15.9375 34.0269 15.9375L29.021 15.9355H24.8384L24.8354 0.0244141L29.0181 0.0253906L29.0454 0.0244141L32.981 0.0351562ZM17.5151 15.9346H13.8403L12.4009 12.4922H5.91553L4.47607 15.9346H0.80127L7.48682 0H10.8296L17.5151 15.9346ZM50.7212 12.7656H58.9878V15.9346H47.0669V0H50.7212V12.7656ZM71.7026 5.92676L75.2397 0H79.1987L73.5298 9.64258V15.9346H69.8755V9.64258L64.2065 0H68.1655L71.7026 5.92676ZM28.5356 9.7168V13.2158H31.4077V13.2148H32.3267C33.2646 13.2147 34.1831 12.4409 34.1831 11.4951V11.4375C34.1831 10.4914 33.2646 9.71789 32.3267 9.71777H31.4077V9.7168H28.5356ZM7.22119 9.36914H11.0952L9.16943 4.74219L7.22119 9.36914ZM28.5356 2.74512V6.24414H31.7534C32.691 6.24414 33.4583 5.47042 33.4585 4.52441V4.4668C33.4585 3.52064 32.6911 2.74609 31.7534 2.74609H31.4204V2.74512H28.5356Z"
                fill="#1F1F1F"
              />
            </Svg>
          </Flex>
        )}
      </Flex>
      <Flex.Row>
        <CartIcon screen={'HOME'} onPressCart={() => {}} />
      </Flex.Row>
    </HeaderContainer>
  );
};

export const HomeHeader = () => {
  return (
    <React.Suspense
      fallback={
        <HeaderContainer justifyContent={'space-between'}>
          <Flex>
            <></>
          </Flex>
          <Flex.Row>
            <CartIcon screen={'HOME'} onPressCart={() => {}} />
          </Flex.Row>
        </HeaderContainer>
      }
    >
      <HomeHeaderContent />
    </React.Suspense>
  );
};
